export enum FodderNeedStepKey {
  PERIODS = 'PERIODS',
  FEEDINGSTUFFS = 'FEEDINGSTUFFS',
  ANIMAL_GROUPS = 'ANIMAL_GROUPS',
  SUMMARY = 'SUMMARY',
}
